import {useTranslation} from "react-i18next";
import Button from "../../../../components/Button.jsx";
import {useErrorTranslation} from "../../../../api/utilities/translateErrorMessage.js";
import useIntegrationScript from "../IntegrationFormInput/useIntegrationScript.js";
import useHostNameXmlLinksIntegrationState from "../IntegrationFormInput/useHostNameXmlLinksIntegrationState.js";
import TextareaWithClipboard from "../../../../components/TextareaWithClipboard.jsx";
import HostNameAndXmlLinkList from "../IntegrationFormInput/HostNameAndXmlLinkList.jsx";
import useAuthorityConfiguration from "../../../../api/utilities/useAuthorityConfiguration.js";
import {ProjectIntegrationsApi} from "../../../../api/authority/generated/index";
import toast from "react-hot-toast";
import {useContext} from "react";
import {GlobalContext} from "../../../../utils/context/GlobalContextProvider.jsx";
import {useNavigate} from "react-router-dom";

export default function ShoptetIntegrationForm({project, projectIntegration}) {
    let {t} = useTranslation();
    let {et} = useErrorTranslation();
    let {resetCurrentUserProjects} = useContext(GlobalContext);
    let navigate = useNavigate();

    let authorityConfiguration = useAuthorityConfiguration();

    let integrationScript = useIntegrationScript('shoptet', projectIntegration?.id);

    let [integrationSettings, setIntegrationSettings] = useHostNameXmlLinksIntegrationState(projectIntegration);

    let createShoptetIntegration = () => {
        new ProjectIntegrationsApi(authorityConfiguration)
            .shoptetIntegration({
                projectId: project.id,
                integrationId: projectIntegration?.id ?? null,
                shoptetIntegrationInput: integrationSettings,
            })
            .then(shoptetIntegrationData => {
                navigate(
                    '/project/' + project.id + '/settings/integrations?integrationId=' + shoptetIntegrationData.id
                );
                resetCurrentUserProjects();
                toast.success(projectIntegration === null ? t('created') : t('saved'));
            })
            .catch(e => et(e).then(toast.error));
    };

    // noinspection JSUnresolvedReference
    return (
        <div className={'flex flex-col gap-2'}>
            {projectIntegration !== null && <>
                <div className={'flex flex-col p-2 border-1 border-slate-400 rounded'}>
                    <strong className={'mt-2'}>{t('integration.shoptet.script-title')}:</strong>

                        <TextareaWithClipboard
                            value={integrationScript}
                            showButton={true}
                            textareaClasses={'min-h-[158px]'}
                        />
                    <small className={'mt-2'}>{t('integration.eprivacy-warning')}</small>
                </div>

                <div className={'min-h-4 max-h-4'}>{/* spacer */}</div>
            </>}

            <HostNameAndXmlLinkList
                project={project}
                projectIntegration={projectIntegration}
                value={integrationSettings.hostNameAndXmlLinkList}
                onChange={(hostNameAndXmlLinkList) => {
                    setIntegrationSettings((integrationSettings) => {
                        return {...integrationSettings, hostNameAndXmlLinkList: hostNameAndXmlLinkList};
                    });
                }}
            />

            <div className={'min-h-4 max-h-4'}>{/* spacer */}</div>

            <div className={'flex justify-end'}>
                <Button
                    className={'button-primary'}
                    onClick={() => createShoptetIntegration()}
                    title={t('project.integration-create')}
                >
                    {projectIntegration
                        ? t('project.integration-update')
                        : t('project.integration-create')}
                </Button>
            </div>
        </div>
    );
}
